import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { CoreModule } from './core/core.module';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { TooltipDirective } from './shared/tooltip/tooltip.directive';

export const appConfig: ApplicationConfig = {
  providers: [
    NgOptimizedImage,
    provideHttpClient(),
    importProvidersFrom(CoreModule),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
  ],
};
